import cookieService from 'services/cookie-service'
import { decodeUrlParams } from 'utils/urls'
import { allowedReferalParams, refvisParams, allowedPartnerParams } from 'config/allowed-cookies'
import sessionStorageService, { storeSessionMarketingItemsAsCookies } from 'services/session-service'

const setupRefvisCookie = (): void => {
  const params = decodeUrlParams(window.location.href)

  const allowedParamNames = refvisParams.map((ap) => ap.name)
  const allowedPartnerNames = allowedPartnerParams.map((ap) => ap.name)

  const refvis = allowedParamNames.reduce((acc, curr) => {
    const paramValue = params[curr]

    /**
     * For compatibility with BI department
     * all partner params should be set as 'uap'
     * except 'bankierID' which should be set as 'bankierID'
     */
    if (curr !== 'bankierID' && allowedPartnerNames.includes(curr)) curr = 'uap'

    if (!paramValue) return acc
    if (curr.includes('utm') || curr === 'ref') return acc ? `${acc}_${paramValue}` : `${paramValue}`
    return `${acc}&${curr}=${paramValue}`
  }, '')

  if (refvis) {
    cookieService.setItem('refvis', refvis, cookieService.maximalCookieTTL)
  }
}

function handleRefererCode(): void {
  const params = new URLSearchParams(window.location.search)
  const refererCode = params.get('refererCode')
  if (refererCode) {
    cookieService.setItem('refererCode', refererCode, cookieService.maximalCookieTTL)
  }
}

function setupCookiesMarketing(): void {
  const urlParams = new URLSearchParams(window.location.hash.substring(2))
  const isEncoded = urlParams.has('data')
  const cookiesFromUrl = cookieService.setupCookiesFromURL(
    allowedReferalParams,
    isEncoded ? decodeUrlParams(window.location.href) : undefined,
  )
  cookieService.setupCookiesFromClient()
  setupRefvisCookie()
  handleRefererCode()
  if (!cookiesFromUrl) {
    storeSessionMarketingItemsAsCookies(allowedReferalParams)
  }
  sessionStorageService.removeItems(allowedReferalParams)
  cookieService.setCookieByParamUrl('bankierID', 'bankiervis')
}

setupCookiesMarketing()
